import React, { useEffect } from 'react';

import LoginEntraId from '../../components/pagesComponents/loginPageComponents/LoginEntraId';
import { useEntraIdLogin } from '../../hooks/useEntraIdLogin';
import { logEntraDeployDebug } from '../../services/env';

const LoginSsoPage: React.FC = () => {
  const { isLoading, error, signIn } = useEntraIdLogin();

  useEffect(() => {
    logEntraDeployDebug();
  }, []);

  return (
    <LoginEntraId
      isLoading={isLoading}
      error={error}
      retry={signIn}
    />
  );
};

export default LoginSsoPage;
